export enum Message {
    NO_TICKETS_TITLE = 'Nenhum ticket encontrado com esse status ou termo pesquisado',
    NO_TICKETS_MESSAGE = 'Nada aqui!',
}
